import React, { useEffect, useState } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { loginRequest } from '../config/msalConfig';

const ProtectedRoute = ({ children }) => {
  const { instance, inProgress, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [loginTriggered, setLoginTriggered] = useState(false);

  // Debug logging
  console.log('ProtectedRoute - isAuthenticated:', isAuthenticated);
  console.log('ProtectedRoute - accounts:', accounts);
  console.log('ProtectedRoute - accounts.length:', accounts.length);
  console.log('ProtectedRoute - inProgress:', inProgress);
  console.log('ProtectedRoute - loginTriggered:', loginTriggered);

  // Auto-trigger Microsoft login when not authenticated
  useEffect(() => {
    const triggerLogin = async () => {
      const hasAccounts = accounts.length > 0;
      const isAuth = isAuthenticated || hasAccounts;
      
      if (!isAuth && !loginTriggered && inProgress !== 'login' && inProgress !== 'handleRedirect') {
        console.log('ProtectedRoute - not authenticated, triggering Microsoft login');
        setLoginTriggered(true);
        
        try {
          await instance.loginRedirect(loginRequest);
        } catch (error) {
          console.error('Auto-login failed:', error);
          setLoginTriggered(false); // Reset to allow retry
        }
      }
    };

    triggerLogin();
  }, [instance, isAuthenticated, accounts, loginTriggered, inProgress]);

  // Show loading while MSAL is handling redirect or login
  if (inProgress === 'login' || inProgress === 'acquireToken' || inProgress === 'handleRedirect' || loginTriggered) {
    console.log('ProtectedRoute - showing loading state');
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        }}
      >
        <CircularProgress size={60} sx={{ color: '#1976d2', mb: 3 }} />
        <Typography variant="h6" sx={{ color: '#1a365d', fontWeight: 600 }}>
          {loginTriggered ? 'Redirecting to Microsoft login...' : 'Authenticating...'}
        </Typography>
      </Box>
    );
  }

  // Check authentication using both methods
  const hasAccounts = accounts.length > 0;
  const isAuth = isAuthenticated || hasAccounts;
  
  console.log('ProtectedRoute - hasAccounts:', hasAccounts);
  console.log('ProtectedRoute - isAuth (combined):', isAuth);

  if (!isAuth) {
    console.log('ProtectedRoute - not authenticated, showing loading while login is triggered');
    // Show loading while login is being triggered
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        }}
      >
        <CircularProgress size={60} sx={{ color: '#1976d2', mb: 3 }} />
        <Typography variant="h6" sx={{ color: '#1a365d', fontWeight: 600 }}>
          Redirecting to Microsoft login...
        </Typography>
      </Box>
    );
  }

  console.log('ProtectedRoute - authenticated, rendering children');
  return children;
};

export default ProtectedRoute;
